/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { FETCH_ACES_ONLINE_CATEGORIES_CHAP_3 } from './actionTypes';

import { fetchAcesOnlineCategoriesChap3Util } from './utils';

/**
 * Contains the action creator functions that update the ACESApplyForBenefits slice of the store.
 *
 * @namespace ACESApplyForBenefitsActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/aces_online_categories_chap3
   *
   * @param {any} callback function to call once this function has finished
   * @function
   * @memberof ACESApplyForBenefitsActions
   */
  static fetchAcesOnlineCategoriesChap3 = (dispatch, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      fetchAcesOnlineCategoriesChap3Util,
      FETCH_ACES_ONLINE_CATEGORIES_CHAP_3,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to fetchAcesOnlineCategoriesChap3.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof ACESApplyForBenefitsActions
   */
  static resetFetchAcesOnlineCategoriesChap3 = (dispatch, data) => {
    const json = {
      type: FETCH_ACES_ONLINE_CATEGORIES_CHAP_3.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to fetchAcesOnlineCategoriesChap3.
   *
   * @param {function} dispatch
   * @function
   * @memberof ACESApplyForBenefitsActions
   */
  static resetFetchAcesOnlineCategoriesChap3Error = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, FETCH_ACES_ONLINE_CATEGORIES_CHAP_3.failureAction);
  };
}
